import { CampaignStatus } from '../dto';
import { CampaignStatusGroup } from '../types';

export const CAMPAIGN_STATUS_GROUPS: Record<
  CampaignStatusGroup,
  CampaignStatus[]
> = {
  [CampaignStatusGroup.InProgress]: [
    CampaignStatus.Draft,
    CampaignStatus.Publishing,
    CampaignStatus.Published,
  ],
  [CampaignStatusGroup.Failed]: [CampaignStatus.PublishingFailed],
  [CampaignStatusGroup.Ready]: [
    CampaignStatus.Configurable,
    CampaignStatus.Configured,
  ],
};
